/**
 * Scrolling Gallery
 * Click an image to scroll it to the center of the viewport
 * Prevents scroll wheel/touch horizontal scrolling
 * Navigate with arrow buttons
 */

class ScrollingGallery {
  constructor(section) {
    this.section = section;
    this.track = section.querySelector('[data-gallery-track]');
    this.items = section.querySelectorAll('[data-gallery-item]');
    this.prevButton = section.querySelector('[data-gallery-nav="prev"]');
    this.nextButton = section.querySelector('[data-gallery-nav="next"]');
    this.currentIndex = 0;
    
    if (!this.track || !this.items.length) return;
    
    this.init();
  }
  
  init() {
    // Prevent horizontal scroll from wheel/touch events
    this.preventHorizontalScroll();
    
    // Add click handlers to scroll items to center
    this.items.forEach((item, index) => {
      item.addEventListener('click', (e) => {
        this.currentIndex = index;
        this.scrollToCenter(item);
      });
    });
    
    // Add navigation button handlers
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.navigatePrev();
      });
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.navigateNext();
      });
    }
  }
  
  preventHorizontalScroll() {
    // Prevent scroll wheel from scrolling horizontally
    this.track.addEventListener('wheel', (e) => {
      if (Math.abs(e.deltaX) > 0) {
        e.preventDefault();
      }
    }, { passive: false });
    
    // Prevent touch/trackpad horizontal scrolling
    let startX = 0;
    
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });
    
    this.track.addEventListener('touchmove', (e) => {
      const deltaX = Math.abs(e.touches[0].clientX - startX);
      const deltaY = Math.abs(e.touches[0].clientY - (e.touches[0].clientY));
      
      // If primarily horizontal scroll, prevent it
      if (deltaX > deltaY) {
        e.preventDefault();
      }
    }, { passive: false });
  }
  
  scrollToCenter(item) {
    const trackRect = this.track.getBoundingClientRect();
    const itemRect = item.getBoundingClientRect();
    
    // Calculate the scroll position that would center the item
    const trackCenter = trackRect.width / 2;
    const itemCenter = itemRect.left - trackRect.left + (itemRect.width / 2);
    const scrollAmount = itemCenter - trackCenter;
    
    // Scroll the track
    this.track.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }
  
  navigatePrev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      // Loop to last item
      this.currentIndex = this.items.length - 1;
    }
    this.scrollToCenter(this.items[this.currentIndex]);
  }
  
  navigateNext() {
    if (this.currentIndex < this.items.length - 1) {
      this.currentIndex++;
    } else {
      // Loop to first item
      this.currentIndex = 0;
    }
    this.scrollToCenter(this.items[this.currentIndex]);
  }
}

// Initialize all scrolling galleries on the page
function initScrollingGalleries() {
  const sections = document.querySelectorAll('.scrolling-gallery');
  sections.forEach(section => {
    new ScrollingGallery(section);
  });
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollingGalleries);
} else {
  initScrollingGalleries();
}

// Re-initialize when sections are loaded in the theme editor
if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.scrolling-gallery')) {
      initScrollingGalleries();
    }
  });
}

